class WarehouseType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'WarehouseType'

export const NORMAL = new WarehouseType(0, 'normal', '普通')
export const SUPERVISE = new WarehouseType(1, 'supervise', '监管')

export const WAREHOUSETYPES = [NORMAL, SUPERVISE]
